import { render } from "./EditorModal.vue?vue&type=template&id=b3d789a4&scoped=true"
import script from "./EditorModal.vue?vue&type=script&lang=ts"
export * from "./EditorModal.vue?vue&type=script&lang=ts"

import "./EditorModal.vue?vue&type=style&index=0&id=b3d789a4&lang=scss"
import "./EditorModal.vue?vue&type=style&index=1&id=b3d789a4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b3d789a4"

export default script